module.exports = __webpack_public_path__ + "img/er_code.33040b3b.png";